import { points } from "./points";
import dayjs from "dayjs";
import { ArcheryProp } from "./type";
import { CLUB_IDS, CURRENT_CLUB_ID } from "./constants";

export const sumPoints = (arr: number[]) =>
  arr?.reduce((acc, val) => acc + points[val].point, 0);

export const checkOnlyNumbers = (input: string): boolean => {
  const regex = /^[0-9]+$/;
  const value = Number(input);
  return regex.test(input) && value > 0;
};

export const orderArchers = (archers: ArcheryProp[]): ArcheryProp[] => {
  if (CURRENT_CLUB_ID == CLUB_IDS.mongolUndesniiKharwaaKholboo) {
    return orderUndesniiArchers(archers);
  }
  return orderMusunArchers(archers);
};

const orderUndesniiArchers = (archers: any): ArcheryProp[] => {
  let ordered: ArcheryProp[] = [];
  let archersSeen = new Set();
  // Order #1
  let temp: any = [];
  archers.map((archer: any) => {
    if (archer.rank && parseInt(archer.rank.order) <= 9) {
      archersSeen.add(archer.id);
      temp.push(archer);
    }
  });

  temp.sort(
    (a: any, b: any) =>
      parseInt(a.rank.order) - parseInt(b.rank.order) ||
      dayjs(a.rateDate).diff(dayjs(b.rateDate))
  );
  ordered = [...temp];

  // Order #2
  temp = [];
  archers.map((archer: any) => {
    if (!archersSeen.has(archer.id)) {
      if (
        archer.rank &&
        archer.rank2 &&
        parseInt(archer.rank.order) >= 12 &&
        parseInt(archer.rank.order) <= 20 &&
        parseInt(archer.rank2.order) === 10
      ) {
        // archer.firstName = `${archer.firstName} - 2`;
        archersSeen.add(archer.id);
        temp.push(archer);
      }
    }
  });

  temp.sort(
    (a: any, b: any) =>
      parseInt(a.rank.order) - parseInt(b.rank.order) ||
      dayjs(a.rateDate2).diff(dayjs(b.rateDate2))
  );
  ordered = [...ordered, ...temp];

  // Order #3
  temp = [];
  archers.map((archer: any) => {
    if (!archersSeen.has(archer.id)) {
      if (parseInt(archer.rank2?.order) === 10) {
        // archer.firstName = `${archer.firstName} - 3`;
        archersSeen.add(archer.id);
        temp.push(archer);
      }
    }
  });

  temp.sort(
    (a: any, b: any) =>
      parseInt(a.rank2?.order) - parseInt(b.rank2?.order) ||
      dayjs(a.rateDate2).diff(dayjs(b.rateDate2))
  );
  ordered = [...ordered, ...temp];

  // Order #4
  temp = [];
  archers.map((archer: any) => {
    if (!archersSeen.has(archer.id)) {
      if (
        archer.rank &&
        archer.rank2 &&
        parseInt(archer.rank.order) >= 12 &&
        parseInt(archer.rank.order) <= 20 &&
        parseInt(archer.rank2.order) === 11
      ) {
        // archer.firstName = `${archer.firstName} - 4`;
        archersSeen.add(archer.id);
        temp.push(archer);
      }
    }
  });

  temp.sort(
    (a: any, b: any) =>
      parseInt(a.rank.order) - parseInt(b.rank.order) ||
      dayjs(a.rateDate2).diff(dayjs(b.rateDate2))
  );
  ordered = [...ordered, ...temp];

  // Order #5
  temp = [];
  archers.map((archer: any) => {
    if (!archersSeen.has(archer.id)) {
      if (parseInt(archer.rank2?.order) === 11) {
        // archer.firstName = `${archer.firstName} - 5`;
        archersSeen.add(archer.id);
        temp.push(archer);
      }
    }
  });

  temp.sort(
    (a: any, b: any) =>
      parseInt(a.rank2.order) - parseInt(b.rank2.order) ||
      dayjs(a.rateDate2).diff(dayjs(b.rateDate2))
  );
  ordered = [...ordered, ...temp];

  // Order #6
  temp = [];
  archers.map((archer: any) => {
    if (
      archer.rank &&
      archer.rank2 &&
      parseInt(archer.rank.order) >= 12 &&
      parseInt(archer.rank.order) <= 20 &&
      parseInt(archer.rank2.order) !== 11 &&
      parseInt(archer.rank2.order) !== 10
    ) {
      // archer.firstName = `${archer.firstName} - 6`;
      archersSeen.add(archer.id);
      temp.push(archer);
    }
  });

  temp.sort(
    (a: any, b: any) =>
      parseInt(a.rank.order) - parseInt(b.rank.order) ||
      dayjs(a.rateDate).diff(dayjs(b.rateDate))
  );
  ordered = [...ordered, ...temp];

  // Order #7
  temp = [];
  archers.map((archer: any) => {
    if (
      archer.rank &&
      parseInt(archer.rank.order) >= 27 &&
      parseInt(archer.rank.order) <= 29 &&
      (!archer.rank2 ||
        (parseInt(archer.rank2.order) !== 11 &&
          parseInt(archer.rank2.order) !== 10))
    ) {
      // archer.firstName = `${archer.firstName} - 6`;
      archersSeen.add(archer.id);
      temp.push(archer);
    }
  });

  temp.sort(
    (a: any, b: any) =>
      parseInt(a.rank.order) - parseInt(b.rank.order) ||
      dayjs(a.rateDate).diff(dayjs(b.rateDate))
  );
  ordered = [...ordered, ...temp];

  // Order #8
  temp = [];
  archers.map((archer: any) => {
    if (
      archer.rank &&
      archer.rank2 &&
      parseInt(archer.rank.order) === 33 &&
      (parseInt(archer.rank2.order) === 30 ||
        parseInt(archer.rank2.order) === 31 ||
        parseInt(archer.rank2.order) === 32)
    ) {
      // archer.firstName = `${archer.firstName} - 6`;
      archersSeen.add(archer.id);
      temp.push(archer);
    }
  });

  temp.sort(
    (a: any, b: any) =>
      parseInt(a.rank2.order) - parseInt(b.rank2.order) ||
      dayjs(a.rateDate2).diff(dayjs(b.rateDate2))
  );
  ordered = [...ordered, ...temp];

  // Order #9
  temp = [];
  let birthNum = 0;
  archers.map((archer: any) => {
    if (!archer.ssn) return;
    birthNum = archer.ssn.slice(2, 10);
    if (!archersSeen.has(archer.id) && birthNum >= 10000000) {
      // archer.firstName = `${archer.firstName} - 7`;
      archersSeen.add(archer.id);
      temp.push(archer);
    }
  });

  temp.sort(
    (a: any, b: any) =>
      // parseInt(a.rank.order) - parseInt(b.rank.order) ||
      parseInt(a.ssn.slice(2, 10)) - parseInt(b.ssn.slice(2, 10))
    // const font = item.ssn.slice(2, 10);
  );
  ordered = [...ordered, ...temp];

  // Order #10
  temp = [];
  birthNum = 0;
  archers.map((archer: any) => {
    if (!archer.ssn) return;
    birthNum = archer.ssn.slice(2, 10);
    if (!archersSeen.has(archer.id) && birthNum <= 10000000) {
      // archer.firstName = `${archer.firstName} - 7`;
      archersSeen.add(archer.id);
      temp.push(archer);
    }
  });

  temp.sort(
    (a: any, b: any) =>
      // parseInt(a.rank.order) - parseInt(b.rank.order) ||
      parseInt(a.ssn.slice(2, 10)) - parseInt(b.ssn.slice(2, 10))
    // const font = item.ssn.slice(2, 10);
  );
  ordered = [...ordered, ...temp];

  // Order #11 - Catch-all for any remaining archers not matched by previous criteria
  temp = [];
  archers.map((archer: any) => {
    if (!archersSeen.has(archer.id)) {
      archersSeen.add(archer.id);
      temp.push(archer);
    }
  });
  ordered = [...ordered, ...temp];

  ordered.map((item, i) => (item.index = i + 1));

  return ordered;
};

export const sortArchersByScore = (archers: ArcheryProp[]): ArcheryProp[] => {
  const getTotalPoints = (archer: ArcheryProp): number => {
    if (archer?.totalScore !== undefined) return archer.totalScore;
    return (
      sumPoints(archer?.hanaPoints || []) +
      sumPoints(archer?.hasPoints || [])
    );
  };

  const getTovkhCount = (archer: ArcheryProp): number => {
    return archer?.tovkhCount || 0;
  };

  const getRankOrder = (archer: ArcheryProp): number => {
    return Number(archer?.rank?.order) || 999;
  };

  const getRankDate = (archer: ArcheryProp): number => {
    const date = archer?.rateDate;
    if (!date) return Number.MAX_SAFE_INTEGER;
    return dayjs(date).valueOf();
  };

  const getBirthDate = (archer: ArcheryProp): number => {
    if (!archer.birthDate) return Number.MAX_SAFE_INTEGER;
    return dayjs(archer.birthDate).valueOf();
  };

  const sorted = [...archers].sort((a, b) => {
    // 1. Sort by total points (descending)
    const pointsA = getTotalPoints(a);
    const pointsB = getTotalPoints(b);
    if (pointsA !== pointsB) return pointsB - pointsA;

    // 2. Sort by Tövkh count (descending)
    const tovkhA = getTovkhCount(a);
    const tovkhB = getTovkhCount(b);
    if (tovkhA !== tovkhB) return tovkhB - tovkhA;

    // 3. Sort by rank order (ascending)
    const rankA = getRankOrder(a);
    const rankB = getRankOrder(b);
    if (rankA !== rankB) return rankA - rankB;

    // 4. Sort by rank date (ascending — older first)
    const dateA = getRankDate(a);
    const dateB = getRankDate(b);
    if (dateA !== dateB) return dateA - dateB;

    // 5. FINAL TIEBREAKER: sort by birth date (ascending — older first)
    const birthA = getBirthDate(a);
    const birthB = getBirthDate(b);
    return birthA - birthB;
  });

  // Assign index for UI table
  sorted.forEach((item, i) => (item.index = i + 1));

  return sorted;
};


// const orderMusunArchers = (archers: ArcheryProp[]): ArcheryProp[] => {
//   return archers.sort((a, b) => {
//     if (b.rank.order !== a.rank.order) {
//       return b.rank.order - a.rank.order;
//     }

//     const dateA = a.rankDate ? new Date(a.rankDate).getTime() : 0;
//     const dateB = b.rankDate ? new Date(b.rankDate).getTime() : 0;

//     return dateA - dateB; // earlier date first
//   });
// };

const orderMusunArchers = (archers: ArcheryProp[]): ArcheryProp[] => {
  const sorted = [...archers].sort((a, b) => {
    // 1) Sort by rank.order (bigger first)
    if (b.rank.order !== a.rank.order) {
      return b.rank.order - a.rank.order;
    }

    // 2) If same → rankDate (oldest first)
    const rankDateA = a.rankDate ? new Date(a.rankDate).getTime() : Infinity;
    const rankDateB = b.rankDate ? new Date(b.rankDate).getTime() : Infinity;
    if (rankDateA !== rankDateB) {
      return rankDateA - rankDateB;
    }

    // 3) If still same → birthDate (oldest first)
    const birthA = a.birthDate
      ? new Date(a.birthDate).getTime()
      : Infinity;

    const birthB = b.birthDate
      ? new Date(b.birthDate).getTime()
      : Infinity;

    return birthA - birthB;
  });

  // Reverse final output (your intended behavior)
  return sorted.reverse();
};
